module.exports = __webpack_public_path__ + "img/icon_map_8_on_101.6dffc459.png";